import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/styles/base.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import headers from '@/components/headers'
import footers from '@/components/footers'
import mains from '@/components/mains'
import bottom from '@/components/bottom'
import advbottom from '@/components/advbottom'
import swiper from '@/components/swiper'
import adva from '@/components/adva'
// import VueQrcodeReader from 'vue-qrcode-reader'
// import VueQrcodeScanner from 'vue-qrcode-scanner'
// Vue.use(VueQrcodeReader)
// Vue.use(VueQrcodeScanner)
Vue.use(ElementUI)
Vue.use(headers)
Vue.use(footers)
Vue.use(mains)
Vue.use(bottom)
Vue.use(advbottom)
Vue.use(swiper)
Vue.use(adva)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
